import * as types from "../actions/actionTypes";
import {isEqual} from "lodash";
const initialState = {
  loading: false,
  deleteProjectLoading: false,
  archiveProjectLoading: false,
  userListLoading: false,
  is_fetched:false,
  data: [],
  premium:{},
  storeData: [],
  deletedProjectId: "",
  archivedProjectId: "",
  userList:[]
};

const Project = (state = initialState, action) => {
  switch (action.type) {
    case types.PROJECT_LIST_REQUEST:
      return { ...state, loading: true };
    case types.PROJECT_LIST_SUCCESS:
      return { ...state, data:action.payLoad.data,loading: false,is_fetched:true, premium: action.payLoad.premium };
    case types.PROJECT_LIST_FAILURE:
      return { ...state, loading: false };

    case types.PROJECT_ACCEPT_REQUEST:
      return { ...state, loading: true };
    case types.PROJECT_ACCEPT_SUCCESS:
      state.data.forEach(project => {
        if (project.id === action.payLoad.id) {
          project.state = 1;
        }
      });
      return { ...state, loading: false };
    case types.PROJECT_ACCEPT_FAILURE:
      return { ...state, loading: false };

    case types.PROJECT_REJECT_REQUEST:
      return { ...state, loading: true };
    case types.PROJECT_REJECT_SUCCESS:
      state.data.forEach((project, i) => {
        if (project.notification_id === action.payLoad) {
          state.data.splice(i, 1);
        }
      });
      return { ...state, loading: false };
    case types.PROJECT_REJECT_FAILURE:
      return { ...state, loading: false };

    case types.PROJECT_STORE_REQUEST:
      return {...state, storeData: [], loading: true};
    case types.PROJECT_STORE_SUCCESS:
      return {...state,storeData: action.payLoad,loading: false};
    case types.PROJECT_STORE_FAILURE:
      return {...state,loading: false};

    case types.PROJECT_UPDATE_REQUEST:
      return {...state,loading: true};
    case types.PROJECT_UPDATE_SUCCESS:
      let edit_data=state.data;
      edit_data.forEach((item,i)=>{
        if(item.project.id===action.payLoad.project.id){
          edit_data[i]=action.payLoad;
        }
      });
      return { ...state, data:edit_data,editedProject: action.payLoad, loading: false };
    case types.PROJECT_UPDATE_FAILURE:
      return {...state,loading: false};


    case  types.PROJECT_DELETE_REQUEST:
      return { ...state,  deleteProjectLoading: true };
    case types.PROJECT_DELETE_SUCCESS:
      const id = action.deletedProjectId;
      const newProjectList = state.data.filter((projects) => (parseInt(projects.project.id) !== parseInt(id)));
      return { ...state, data: newProjectList, deletedProjectId: id, deleteProjectLoading: false };
    case types.PROJECT_DELETE_FAILURE:
      return { ...state, deleteProjectLoading: false };

    case  types.PROJECT_ARCHIVE_REQUEST:
      return { ...state,  archiveProjectLoading: true, loading: !action.data.archive_state  };
    case types.PROJECT_ARCHIVE_SUCCESS:

      let index  = state.data.findIndex((obj => obj.project.id === action.id));
      let arr = [...state.data];
      arr[index] = {...arr[index], project:{...arr[index].project, is_archived: action.data.archive_state }};
      return { ...state, archivedProjectId: action.id, archiveProjectLoading: false, data: arr, loading: false };
    case types.PROJECT_ARCHIVE_FAILURE:
      return { ...state, archiveProjectLoading: false, loading: false };

    case types.PROJECT_USERS_LIST_REQUEST:
      return {...state, userListLoading:true};
    case types.PROJECT_USERS_LIST_SUCCESS:
      return {...state, userListLoading:false, userList:action.payLoad};
    case types.PROJECT_USERS_LIST_FAILURE:
      return {...state, userListLoading:false};
    default:
      return state;
  }
};

export default Project;

